import ConversationUpdater from '../../conversation/lib/conversation_updater';
import createTaskReopenedItem from 'scripts/domain/factories/conversation_item/create_task_reopened_item';
import MarkTaskOpened from './mark_task_opened';

export default class MarkTaskOpenedAndCreateReopenedItem extends ConversationUpdater {
  run({ conversationItem, location }) {
    this.context.executeAction(MarkTaskOpened, { conversationItemId: conversationItem.id });
    let reopenedItem = createTaskReopenedItem({
      agentId: this.currentAgent.id,
      note: conversationItem.content.note,
      taskItemId: conversationItem.id,
      customerId: this.currentCustomerId,
    });
    this.addConversationItem(reopenedItem);

    this.context.analytics.track('Task Reopened', {
      itemId: conversationItem.id,
      location,
    });
  }

  get currentAgent() {
    return this.context.stores.currentAgent.get();
  }
}

MarkTaskOpenedAndCreateReopenedItem.actionName = 'MarkTaskOpenedAndCreateReopenedItem';



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation_item/task/mark_task_opened_and_create_reopend_item.js